






































import { bus } from "@/bus";
import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import QrcodeVue from "qrcode.vue";
import i18n from "@/i18n";
import { TranslateResult } from "vue-i18n";

@Component({
    components: {
        QrcodeVue
    }
})
export default class QrcodeComponentForm extends Vue {
    @Prop() vsid!: string;
    showQrInput = false;
    qrInputValue = "";
    qrcodeErrorMessage:TranslateResult = "";
    isInputFocus = false;
    isActiveError = false;
    isQrCodeButtonActive = false;
    isUrlValidState: any = null;

    @Watch("qrInputValue")
    onItemChanged(value: any) {
        // Reset Error State on Input text change.
        this.resetValidationState();
        this.emptyErrorMessage();
        if (value !== "" && this.inputFocusState) {
            this.isQrCodeButtonActive = true;
        } else {
            this.isQrCodeButtonActive = false;
        }
    }

    get properties(): fixedHtmlData {
        return ((this.$parent as any).localProperties.data).filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    // Quitezone for qrcode, one quitezone will be 10px and height and width to match size.
    get qrcodeStyling() {
        return `
            padding: ${this.properties.qrCodeQuiteZone}0px;
            height: ${this.properties.qrCodeSize}px;
            width: ${this.properties.qrCodeSize}px;
        `;
    }

    get placeHolderDynamicFontSize() {
        // return fontsize according to div size for empty qrcode state placeholder.
        return `
            font-size: ${parseInt(this.properties.qrCodeSize) / 5}px;
        `;
    }

    get subPlaceHolderDynamicFontSize() {
        // return fontsize according to div size for empty qrcode state sub placeholder.
        return `
            font-size: ${parseInt(this.properties.qrCodeSize) / 8}px;
        `;
    }

    get urlValidState() {
        return this.isUrlValidState;
    }

    get inputFocusState() {
        return this.isInputFocus;
    }

    get errorMessageState() {
        return this.isActiveError;
    }

    get qrCodeButtonState() {
        return this.isQrCodeButtonActive;
    }

    mounted() {
        bus.$on("getComponentData", () => {
            if (this.$refs.qrcode) {
                const qrcode = (this.$refs.qrcode as any).element.value;
                this.properties.qrCodeValue = qrcode;
            }
        });
        this.qrInputValue = this.properties.qrCodeValue;
    }

    destroyed() {
        bus.$off("getComponentData");
    }

    onQrCodeInput(input: string) {
        if (input === "") {
            this.properties.qrCodeValue = "";
        }
    }

    validateUrlInput() {
        if (this.qrInputValue === "") {
            return false;
        }
        // Validate url using regex
        const pattern = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
        const isValid = pattern.test(this.qrInputValue);
        if (isValid) {
            if (this.qrInputValue.length > 1273) {
                this.invalidUrlState();
                const errorMessage = i18n.t("posts.qrcode.errorMessage.characterLimitExceeded");
                this.showErrorMessage(errorMessage);
            } else {
                this.validUrlState();
            }
        } else {
            if (this.qrInputValue === "") {
                this.validUrlState();
            } else {
                this.invalidUrlState();
                const errorMessage = i18n.t("posts.qrcode.errorMessage.invalidUrl");
                this.showErrorMessage(errorMessage);
            }
        }
    }

    onInputFocusIn() {
        this.isInputFocus = true;
    }

    onInputFocusOut() {
        this.isInputFocus = false;
    }

    invalidUrlState() {
        this.isUrlValidState = false;
        this.properties.qrCodeValue = "";
    }

    validUrlState() {
        this.properties.qrCodeValue = this.qrInputValue;
        this.isUrlValidState = true;
        // this.emptyErrorMessage();
    }

    showErrorMessage(message: TranslateResult) {
        this.qrcodeErrorMessage = message;
        this.isActiveError = true;
    }

    emptyErrorMessage() {
        this.qrcodeErrorMessage = "";
        this.isActiveError = false;
    }

    resetValidationState() {
        this.isUrlValidState = null;
    }

    clearQrCode() {
        this.qrInputValue = "";
        this.properties.qrCodeValue = "";
    }
}
